import { usePublicApi } from "api/setup";
import { ApiError } from "api/shared";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

interface BrandingResponse {
  colors: {
    primary?: string;
  };
  icon: {
    image: {
      src?: string;
    };
  };
  logo: {
    image: {
      src?: string;
    };
  };
  help: {
    description: string;
    link: {
      text?: string;
      href?: string;
    };
  };
  dataSecurity: {
    description?: string;
    link: {
      text?: string;
      href?: string;
    };
  };
}

export const useGetBrandingQuery = () => {
  return usePublicApi<BrandingResponse, ApiError>(
    {
      url: formatUrl(api.profile.branding),
    },
    {
      manual: false,
    }
  );
};
